import React from 'react';

export default () => {
    return (
        <p className="aui-small my-2">
            This online valuation is a guide only and is based on the information provided and the average quality of similar vehicles.
            Upon inspection of your vehicle by an Audi dealer the price could be higher or lower.
            This is impacted by several factors including; options fitted, condition, service history, odometer reading, damage and wear and tear.
            Please contact your local dealer to receive a formal estimate on your trade-in.
        </p>
    )
};
